import { Box, HStack, Text, Tag } from '@vimeo/bokeh';
import { translate } from '@vimeo/i18n-runtime';

import { Category } from '../../types';

export function Categories({
  categories,
  onClick,
  isCategoriesLinkEnabled = false,
}: {
  categories: Category[];
  onClick?: () => void;
  isCategoriesLinkEnabled: boolean;
}): React.ReactElement {
  return (
    <>
      <Text as="h2" variant="heading-sm">
        {translate('Categories')}
      </Text>
      <Box as="nav" aria-label="Video Categories" data-testid="categories-nav">
        <HStack as="ul" wrap="wrap" spacing={200}>
          {categories.map((category) => (
            <li key={category.name}>
              {isCategoriesLinkEnabled ? (
                <a href={category.link} onClick={onClick} aria-label="Link to category">
                  <Tag size="sm" fontSize="text-sm">
                    {category.name}
                  </Tag>
                </a>
              ) : (
                <Tag cursor="default" size="sm" fontSize="text-sm">
                  {category.name}
                </Tag>
              )}
            </li>
          ))}
        </HStack>
      </Box>
    </>
  );
}
